import React from "react";

export default function SafeImage({ fallback = "/favicon.png", alt = "", ...props }) {
  const handleError = (event) => {
    if (!event.currentTarget.src.endsWith(fallback)) event.currentTarget.src = fallback;
  };

  return <img {...props} alt={alt} onError={handleError} />;
}
